<template>
  <div class="container">
    <div class="file">
      <!-- <h3 v-if="isProductFlowEnabled">{{ $t('addPvideo') }}</h3>
      <h3 v-else>{{ $t('addEvideo') }}</h3> -->
      <div class="tipWrapper">
        <div class="help-tip">
          <p>
            {{ $t('proposedDim') }}: <strong>1920×1080 px, 16:9</strong> <br />
            {{ $t('proposedFormate') }}: <strong>mp4 </strong><br />
            {{ $t('maxSize') }}: <strong>5Mb</strong>
          </p>
        </div>
      </div>
      <form @submit.prevent="onSubmit" enctype="multipart/form-data">
        <div class="upload-btn-wrapper">
          <button class="btnUpload">{{ $t('uploadFile') }}</button>
          <input type="file" ref="file" @change="onSelect" id="input-tag" />
        </div>
		<br/>
        <div v-if="isVideoAvailable || product.video_path">
          <video
            controls
            width="320"
            height="240"
            id="video-tag"
            :src="product.video_path ? `${product.video_path}` : blobURL"
          >
            Your browser does not support the video tag.
          </video>
        </div>
        <br />
        <div class="fields">
          <button class="edit-btn">
            <!-- <font-awesome-icon class="icon" icon="upload" /> -->
            <span> {{ $t('save') }} </span>
          </button>
        </div>
      </form>
      <button class="delete-btn" v-if="product.video_path" @click="deleteVideo">
        <font-awesome-icon class="icon" icon="trash" />
        <span> {{ $t('delete') }} </span>
      </button>
      <div v-if="errMessage" class="errMessage">
        <h5>{{ errMessage }}</h5>
      </div>
      <div class="successMessage">
        <h5>{{ successMessage }}</h5>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'

// const videoSrc = document.querySelector("#video-source");
// const videoTag = document.querySelector("#video-tag");
// const inputTag = document.querySelector("#input-tag");

// inputTag.addEventListener('change',  readVideo)

export default {
  name: 'videoUpload',
  data() {
    return {
      file: '',
      errMessage: '',
      successMessage: '',
      isVideoAvailable: false,
      baseUrl: process.env.VUE_APP_API_URL,
      blobURL: '',
    }
  },
  methods: {
    onSelect() {
      const allowedTypes = ['video/mp4', 'video/mpeg-4']
      const file = this.$refs.file.files[0]
      console.log(file)
      this.file = file
      if (!allowedTypes.includes(file.type)) {
        this.errMessage = 'Only .mp4 and .mpeg-4 formats are acceptable'
      } else if (file.size > 3500000) {
        this.errMessage = 'Too large, max size allowed is 3.5Mb'
      } else {
        this.errMessage = ''
        this.isVideoAvailable = true
        this.blobURL = URL.createObjectURL(file)
      }
      setTimeout(() => this.errMessage = '', 3000)
    },
    async onSubmit() {
      const formData = new FormData()
      formData.append('file', this.file)
      const url = this.isProductFlowEnabled
        ? `${process.env.VUE_APP_API_URL}/uploadsVid?product_id=${this.product.id}`
        : `${process.env.VUE_APP_API_URL}/uploadsVid?experience_id=${this.product.id}`
      try {
        const response = await axios.post(url, formData)
        this.product.video_path = response.data.cloudUrl
        this.successMessage = this.$t('uploadSuccess')
        setTimeout(() => this.successMessage = '', 3000)
      } catch (err) {
        this.successMessage = err.response.data.error
        setTimeout(() => this.successMessage = '', 3000)
      }
    },
    async deleteVideo() {
      const url = `${process.env.VUE_APP_API_URL}/product/video?product_id=${this.product.id}&&video_path=${this.product.video_path}`
      try {
        await axios.delete(url)
        this.product.video_path = null
        this.isVideoAvailable = false
        this.successMessage = this.$t('deletedVideoMsg')
        setTimeout(() => this.successMessage = '', 3000)
      } catch (err) {
        this.successMessage = err.response.data.error
        setTimeout(() => this.successMessage = '', 3000)
      }
    }
    // readVideo(event) {
    //   console.log(event.target.files)
    //   if (event.target.files && event.target.files[0]) {
    //     var reader = new FileReader();

    //     reader.onload = function(e) {
    //       console.log('loaded')
    //       videoSrc.src = e.target.result
    //       videoTag.load()
    //     }.bind(this)

    //     reader.readAsDataURL(event.target.files[0]);
    //   }
    // }
  },
  props: {
    product: {
      type: Object,
      required: true,
    },
    isProductFlowEnabled: {
      type: Boolean,
      required: true,
    },
  },
}
</script>

<style lang="scss" scoped>
.errMessage {
  color: var(--primaryDark);
  padding: 10px 2px;
}
.successMessage {
  color: var(--bg);
  padding: 10px 2px;
}
.container {
  display: inline-block;
  width: 80%;
  padding: 30px;
}

.icon {
  font-size: 1.3em;
  padding: 1px;
}

form {
  padding-top: 0px;
  width: 100%;
}
.upload-btn-wrapper {
  position: relative;
  overflow: hidden;
  display: inline-block;
}

.btnUpload {
  border: 2px solid gray;
  color: gray;
  background-color: white;
  padding: 8px 20px;
  border-radius: 8px;
  font-size: 20px;
  font-weight: normal;
  cursor: pointer !important;
}

.btnUpload:hover {
  border: 2px solid var(--primaryDark);
  color: var(--primaryDark);
}
.btnUpload:active {
  background-color: var(--primaryDark);
}

.upload-btn-wrapper input[type='file'] {
  font-size: 100px;
  position: absolute;
  left: 0;
  top: 0;
  opacity: 0;
}

.edit-btn {
  background: var(--bg-light);
  color: var(--bright);
  padding: 0.5em;
  margin: auto !important;
  letter-spacing: 3px;
  border: none;
  border-radius: 3.5px;
  width: 230px;
  height: 40px;
}

.delete-btn {
  background: var(--primaryDark);
  color: var(--bright);
  padding: 0.5em;
  margin: auto !important;
  letter-spacing: 3px;
  border: none;
  border-radius: 3.5px;
  width: 230px;
  height: 40px;
  cursor: pointer;
}

/*** TOOL TIP CSS ***/
.tipWrapper {
  position: relative;
}

.help-tip {
  position: absolute;
  bottom: 10px;
  right: 50px;
  text-align: center;
  background-color: var(--grey-Dark);
  border-radius: 50%;
  width: 24px;
  height: 24px;
  font-size: 12px;
  line-height: 26px;
  cursor: default;
  z-index: 1;
  transition: all 0.5s cubic-bezier(0.55, 0, 0.1, 1);
}

.help-tip:hover {
  cursor: pointer;
  background-color: var(--primaryDark) !important;
}

.help-tip:before {
  content: '?';
  font-weight: 700;
  color: #fff;
}

.help-tip p {
  visibility: hidden;
  opacity: 0;
  text-align: left;
  background-color: var(--grey-Dark);
  padding: 20px;
  width: 300px;
  position: absolute;
  border-radius: 4px;
  right: -4px;
  color: #fff;
  font-size: 13px;
  line-height: 1.2rem;
  transform: scale(0.7);
  transform-origin: 100% 0%;
  transition: all 0.5s cubic-bezier(0.55, 0, 0.1, 1);
}

.help-tip:hover p {
  cursor: default;
  visibility: visible;
  opacity: 1;
  transform: scale(1);
}
.help-tip:active p {
  cursor: default;
  visibility: visible;
  opacity: 1;
  transform: scale(1);
}

.help-tip p:before {
  position: absolute;
  content: '';
  width: 0;
  height: 0;
  border: 6px solid transparent;
  border-bottom-color: var(--grey-Dark);
  right: 10px;
  top: -12px;
}

.help-tip p:after {
  width: 100%;
  height: 40px;
  content: '';
  position: absolute;
  top: -5px;
  left: 0;
}

.help-tip a {
  color: #fff;
  font-weight: 700;
}

.help-tip a:hover,
a:active .help-tip a:focus {
  color: #fff;
  text-decoration: underline;
}
// end of question tooltip//

@media screen and (max-width: 560px) {
  .container {
    width: 100%;
    padding: 10px;
    text-align: center !important;
    margin-left: 0 !important;
  }
  .help-tip {
    right: -5px;
  }
  .help-tip p {
    width: 1370%;
  }
  #video-tag {
    width: 100% !important;
  }
}
</style>
